var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('page-top'),_c('IndexHeader',{attrs:{"userInfo":_vm.userInfo}}),_c('IndexBody',{attrs:{"canAdd":_vm.status === 2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }